<template>
    <article class="article"
             :class="{ 'article--single' : fullView, 'is-closing' : isClosing, 'article--bulletin' : layout === 'bulletin', 'article--impression' : layout === 'impression', 'no-scroll' : galleryOpen }"
             :style="style"
             :id="uid" @click="showFullView">


        <figure class="article-banner article-banner--video" v-if="article.youtube.length">
            <youtube class="block-video" :player-vars="{showinfo : 0,modestbranding:1, rel:0}" :video-id="article.youtube[0]" ref="youtube"></youtube>
        </figure>

        <figure class="article-banner" v-else-if="article.images.length">

            <img v-if="fullView == false" :src="article.images[0].url" :alt="article.images[0].title" />
            <img v-else :src="article.images[0].urlOrig" :alt="article.images[0].title" />
        </figure>

        <header class="article-header" v-if="layout !== 'impression' || fullView">
            <template v-if="layout == 'news'">
                <h1>{{ article.title }}</h1>
            </template>

            <p class="meta">
                <template v-if="isNew"><span class="category category--new">Neu</span></template>
                <template v-if="layout !== 'news'">
                    <span class="author">{{ article.author.name }}</span>
                </template>
                <span class="category" v-if="available_categories" v-for="category in articleCategories" v-bind:key="category.uid">{{ category.title }}</span>
                <time :datetime="article.datetime | toMiliSeconds | dateFormat('Y-m-d')">{{
                        article.datetime |
                            toMiliSeconds |
                            dateFormat( "d. F Y" )
                                                                                         }}
                </time>
            </p>
            <p class="article-controls" v-if="fullView && ! isClosing">
                <span class="article-close" @click.stop="closeFullView"><i class="icon-zurueck"></i></span>
                <span @click.stop="addLike( )" :class="{'is-liked': this.isLiked}" v-if="fullView" class="article-like"><i class="icon-like"></i></span>
            </p>
        </header>

        <template v-if="layout === 'news'">

            <div class="article-intro" v-if="(fullView && article.teaser !== '') || !fullView">
                <p v-html="generatedTeaser"></p>
            </div>

            <template v-if="fullView">
                <div class="article-content">
                    <div v-html="article.bodytext"></div>
                    <download-list :files="article.downloads" v-if="article.downloads.length" />
                    <p v-if="hasGallery"><span @click="openGallery" class="button">Galerie <i class="icon-picture"></i></span></p>
                </div>
                <transition name="slide-left">
                    <gallery :images="gallery" v-if="galleryOpen" />
                </transition>

            </template>

        </template>
        <template v-else>

            <template v-if="fullView === false">
                <div class="article-intro" v-if="article.teaser">
                    <p v-text="article.teaser"></p>
                </div>
                <div class="article-intro" v-else-if="!article.teaser">
                    <p>{{ article.bodytext | truncate }}</p>
                </div>
            </template>

            <div class="article-content" v-else>
                <div v-html="article.bodytext"></div>
            </div>

        </template>

        <footer class="article-footer">
            <template v-if="layout === 'news'">

                <!--<address rel="author" class="article-author" v-if="layout == 'impression'" v-text="article.author.name"></address>-->
                <template v-if="!fullView">
                    <div class="article-social">
                        <span v-if="article.comments.length > 0">{{ article.comments.length }} {{ 'Kommentar' | pluralize(article.comments.length) }} </span><span v-else>0 Kommentare</span>
                        <span @click.stop="addLike( )" :class="{'is-liked': this.isLiked}" class="article-like"><i class="icon-like"></i><span v-text="likeCount"
                                                                                                                                               v-if="article.likes.length > 0"
                                                                                                                                               class="article-like_count"></span></span>
                    </div>
                </template>
                <template v-else>
                    <comment-block :comments="article.comments" :newsid="article.uid"></comment-block>
                </template>

            </template>

            <template v-else-if="layout === 'impression'"> <!-- Impression -->

                <div class="article-social" v-if="! fullView">
                    <address rel="author" class="article-author" v-text="article.author.name"></address>
                    <!-- <span v-if="article.comments.length > 0">{{article.comments.length}} {{'Kommentar' | pluralize(article.comments.length)}} </span><span v-else>0 Kommentare</span>-->
                    <span @click.stop="addLike( )" :class="{'is-liked': this.isLiked}" class="article-like"><i class="icon-like"></i><span v-text="likeCount"
                                                                                                                                           v-if="article.likes.length > 0"
                                                                                                                                           class="article-like_count"></span></span>
                </div>
                <template v-else>
                    <comment-block :comments="article.comments" :newsid="article.uid" :target="layout"></comment-block>
                </template>

            </template>

            <template v-else> <!-- Bulletin -->

                <div class="article-social">
                    <address rel="author" class="article-author" v-text="article.author.name"></address>
                    <!-- <span v-if="article.comments.length > 0">{{article.comments.length}} {{'Kommentar' | pluralize(article.comments.length)}} </span><span v-else>0 Kommentare</span>-->
                    <span @click.stop="addLike( )" :class="{'is-liked': this.isLiked}" class="article-like"><i class="icon-like"></i><span v-text="likeCount"
                                                                                                                                           v-if="article.likes.length > 0"
                                                                                                                                           class="article-like_count"></span></span>
                </div>
                <template v-if="fullView">
                    <comment-block :comments="article.comments" :newsid="article.uid" :target="layout"></comment-block>
                </template>

            </template>
        </footer>
    </article>
</template>

<script>
import { TweenMax } from 'gsap';
import Gallery from './Gallery';
import KappNewsComment from './KappNewsComment';
import store from "@/utils/store";
import api, { ApiDefaults } from '@/utils/api_call';
import { NEWS_SET_LIKES, ARTICLE_UPDATE } from '@/utils/store/actions/general';
import Downloadlist from '../subparts/Downloadlist';

const FULLVIEW_TIMING = .5;

export default {
    name: "KappNews",
    components: {
        'gallery': Gallery,
        'commentBlock': KappNewsComment,
        'download-list': Downloadlist
    },
    props: {
        article: {
            required: true
        },
        uid: {
            type: Number,
            required: true
        },
        available_categories: {
            type: Array | Object
        },
        layout: {
            type: String,
            default: 'news'
        },
        like_settings: {
            type: Array | Object,
            default: function () {
                return {
                    pid: 17,
                    target: 'news'
                };
            }
        }
    },
    data() {
        return {
            fullView: false,
            style: {},
            startPosition: {},
            endPosition: {
                width: window.innerWidth,
                height: window.innerHeight,
                top: 0,
                left: 0
            },
            animation: null,
            isClosing: false,
            galleryOpen: false
        };
    },
    filters: {

        truncate: function ( str ) {
            let div = document.createElement("div");
            div.innerHTML = str;
            let text = div.textContent || div.innerText || "";
            return text.toString().substring(0, 90) + "...";
        }
    },
    methods: {

        closed: function () {

            this.$el.style.position = 'static';

            if ( this.$el.previousElementSibling ) {
                this.$el.previousElementSibling.style.marginBottom = 0;
            }
            else if ( this.$el.nextElementSibling ) {
                this.$el.nextElementSibling.style.marginTop = '15px';
            }
            this.isClosing = false;
            this.fullView = false;
        },
        addLike() {
            let postData = new URLSearchParams();
            postData.append('tx_c3json_jsondataplugin[controller]', 'JsonDataNews');
            postData.append('tx_c3json_jsondataplugin[action]', 'toggleLike');
            postData.append('tx_c3json_jsondataplugin[news]', this.article.uid);
            postData.append('tx_c3json_jsondataplugin[user]', store.getters.getProfile.uid);

            let apiParams = Object.assign({}, ApiDefaults, {
                params: {id: this.like_settings.pid},
                method: 'post',
                data: postData
            });
            api(apiParams).then(
                              ( response ) => {
                                  if ( typeof response.data.newsDetail != 'undefined' ) {
                                      // this.item.likes = response.data.newsDetail;
                                      this.$store.commit(ARTICLE_UPDATE, {article: this.article, newData: {likes: response.data.newsDetail}, target: this.like_settings.target});
                                  }
                                  else {
                                      // this.item.likes = response.data;
                                      this.$store.commit(ARTICLE_UPDATE, {article: this.article, newData: {likes: response.data}, target: this.like_settings.target});
                                  }

                              }
                          )
                          .catch(error => console.log('Error', error));

        },
        closeFullView() {
            Events.$emit('lightbox', {state: false, uid: this.article.uid});

            this.isClosing = true;
            TweenMax.fromTo(this.$el, FULLVIEW_TIMING,
                this.endPosition,
                Object.assign(this.startPosition, {onComplete: this.closed, ease: Back.easeOut.config(1)})
            );
        },

        showFullView() {
            if ( this.fullView ) return;

            Events.$emit('lightbox', {state: true, uid: this.article.uid});

            let elStyle = window.getComputedStyle(this.$el),
                mTop = parseInt(elStyle.getPropertyValue('margin-top')),
                topPosition = (document.querySelector('.content-wrap').scrollTop * -1);

            topPosition += this.$el.offsetTop;

            this.startPosition = {
                position: 'fixed',
                top: topPosition + 'px', // #app paddingTop
                left: this.$el.offsetLeft + 'px',
                width: this.$el.offsetWidth + 'px',
                height: this.$el.offsetHeight + 'px'
            };

            TweenMax.fromTo(
                this.$el,
                FULLVIEW_TIMING,
                this.startPosition,
                Object.assign(this.endPosition, {ease: Back.easeOut.config(1)})
            );

            let prev = this.$el.previousElementSibling;
            if ( prev ) {
                prev.style.marginBottom = ((mTop * 2) + this.$el.offsetHeight) + 'px';
            }
            else {
                let next = this.$el.nextElementSibling;
                if ( next )
                    next.style.marginTop = ((mTop * 2) + this.$el.offsetHeight) + 'px';
            }

            this.$ga.event({
                eventCategory: 'Aktuelles',
                eventAction: 'Einzelansicht',
                eventLabel: this.article.title
            });

            this.fullView = true;
        },
        openGallery() {
            this.galleryOpen = !this.galleryOpen;
        }
    },
    computed: {
        relatedNews() {
            return [];
        },
        likeCount() {
            let cnt = this.article.likes.length;
            if ( cnt > 99 ) {
                return '99+';
            }

            return cnt;
        },
        isLiked() {
            let likes = [].concat(this.article.likes);
            if ( typeof likes !== 'object' ) likes = [];
            return likes.indexOf(store.getters.getProfile.uid) !== -1;
        },
        isNew() {
            return this.$store.getters.getLastLogin < new Date(this.article.datetime * 1000);
        },
        articleCategories: function () {
            let categories = this.available_categories,
                articleCategories = [];

            for ( let cat in categories ) {
                let cid = categories[ cat ].uid;
                if ( Array.isArray(this.article.categories) ) {
                    if ( this.article.categories
                             .find(function ( el ) {
                                 return parseInt(el) === parseInt(cid);
                             }.bind(cid)) ) {
                        articleCategories[ articleCategories.length ] = categories[ cat ];
                    }
                }
                else {
                    articleCategories[ 0 ] = this.article.categories;
                }
            }

            return articleCategories;
        },
        hasGallery() {
            return this.article.images.length > 1;
        },
        gallery() {
            let images = Array.from(this.article.images);
            if ( images.length <= 1 )
                return [];
            else if ( this.article.youtube.length === 0 )
                return images.splice(1);
            else
                return images;

        },
        generatedTeaser() {

            if ( this.article.teaser === "" ) {
                let text = this.article.bodytext.toString().replace(/(<([^>]+)>)/gi, "");
                return text.substr(0, 120) + "&hellip;";
            }
            else {
                return this.article.teaser;
            }
        }
    },
    created() {
        this.$pluralize.addPluralRule(/Kommentar$/i, 'Kommentare');
        Events.$on('subpage.close', () => {
            this.galleryOpen = false;
        });
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/KappNews.vue